export const domain = 'BrandInfo';

// action types
export const CLEAR_FETCH_ERROR = `${domain}/CLEAR_FETCH_ERROR`;
export const FETCH_ERROR = `${domain}/FETCH_ERROR`;
export const IS_FETCHING = `${domain}/IS_FETCHING`;
export const RECEIVE_BRAND_INFO = `${domain}/RECEIVE_LOGO`;
